import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { PatientInvitationsApi } from '../../../apis/PatientInvitationsApi/PatientInvitationsApi.ts';

export function usePostAcceptInvitation() {
  const queryClient = useQueryClient();
  return useMutation<void, AppMedError, string>({
    mutationKey: [QueryKeys.patientInvitations, 'accept'],
    mutationFn: async (token: string) => {
      return await PatientInvitationsApi.postAcceptInvitation(token);
    },
    onSuccess: () => {
      // AcceptInvitation creates the eICF consent server-side when the
      // facility has an active template — refetch so the blocking modal
      // appears immediately on the next render.
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.eicfActiveConsent],
      });
    },
  });
}
